import { svg } from "lit";
const icon = svg `<path d="M5.8335 29.3914V27.2974H34.1667V29.3914H5.8335ZM5.8335 21.0473V18.9534H34.1667V21.0473H5.8335ZM5.8335 12.7033V10.6094H34.1667V12.7033H5.8335Z" fill="currentColor"/>`;
export default icon;
